import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Router } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { StorageService } from './storage.service';

@Injectable()
export class CommonService {

    private notifSubject$ = new Subject<any>();
    private noticesSubject$ = new Subject<any>();

    constructor(
        private router: Router,
        private storageService: StorageService
    ) {
    }

    setNotifsData(data: any) {
        this.notifSubject$.next(data);
    }

    getNotifs() {
        return this.notifSubject$;
    }

    setNoticesData(data: any) {
        this.noticesSubject$.next(data);
    }

    getNotices() {
        return this.noticesSubject$;
    }

    setRedirectTo(path: any, queryParams: any) {
        const redirectTo = {
            path: path,
            queryParams: queryParams
        };
        this.storageService.set('redirect_to', redirectTo);
    }

    getRedirectTo() {
        return this.storageService.get('redirect_to') ? JSON.parse(this.storageService.get('redirect_to')) : false;
    }

    removeRedirectTo(): void {
        this.storageService.delete('redirect_to');
    }

    getAutoSelectCompanyID() {
        const redirectTo = this.getRedirectTo();
        if (redirectTo) {
            if (redirectTo['queryParams'] && redirectTo['queryParams']['company_id']) {
                return parseInt(redirectTo['queryParams']['company_id'], 10);
            }
        }
        return false;
    }

    handleRedirectTo(defaultData: any = {}) {
        let path = '/products';
        let queryParams = {};
        const redirectTo = this.getRedirectTo();
        if (redirectTo) {
            path = redirectTo.path;
            queryParams = redirectTo.queryParams;
        }
        else if (defaultData.path) {
            path = defaultData.path;
            if (defaultData.queryParams) {
                queryParams = defaultData.queryParams;
            }
        }
        this.removeRedirectTo();
        if (path.startsWith('/')) {
            path = path.slice(1);
        }

        if (queryParams['company_id']) {
            delete queryParams['company_id'];
        }
        this.router.navigate(['/' + path], {queryParams: queryParams});
    }

}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/services/common.service.ts